import SiafLiteApiRepository from "../../external/siafLiteApi";

class CstService {
  constructor() {
    this.urlBase = "/fiscal/cst";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAllCstIcms(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/icms`).patch(body);
  }

  getIbsById(id) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/ibs`).getById(id);
  }

  getAllCstIbs(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/ibs`).patch(body);
  }

  getAllClassificacoesIbs(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/classificacoes-ibs`).patch(body);
  }

  getAllCodigosCredPres() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/codigos-cred-pres`).patch();
  }
}

export default CstService;
